import React from 'react'
import Dashboard from './AdminNavPages/Dashboard';
import SideNav from './SideNav';


export default function AdminDashboard() {
  return (
    <div className="min-h-screen bg-gradient-to-r from-purple-100 to-teal-100">  
      
      <Dashboard/>
      
      <div>
    </div>
    </div>
  )
}
